<template>
  <t-modal
    :header="$t('actions.insert_section')"
    data-testid="dialog"
    xs
    header-low
    @close="() => (showAddDialog = false)"
  >
    <template #dialog-body>
      <div class="grid grid-cols-2 justify-center gap-2 px-5 pb-5">
        <div v-for="_type in types" :key="_type" @click="addSection(_type)">
          <Structure
            :key="_type"
            :disable-notification="true"
            :type="_type"
            :data-cols="_type"
          ></Structure>
        </div>
      </div>
    </template>
  </t-modal>
</template>

<script lang="ts" setup>
  import { resolve } from "../columnResolver";
  import Structure from "@/forms/components/StructuresContainer/_internal/Structure/Structure.vue";
  import { useDialogsStore } from "@/stores/dialogs";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TModal } from "@topol/twig-ui";
  import { ref, computed } from "vue";

  const types = ref([
    "100",
    "50-50",
    "33.33-33.33-33.33",
    "25-25-25-25",
    "40-60",
    "60-40",
    "25-75",
    "75-25",
    "25-25-50",
    "50-25-25",
  ]);

  const dialogsStore = useDialogsStore();
  const mjmlStore = useMjmlStore();

  const direction = computed(() => {
    return dialogsStore.addStructureDialog.addDirection;
  });
  const showAddDialog = computed({
    get() {
      return dialogsStore.addStructureDialog.opened;
    },
    set() {
      dialogsStore.closeStructureDialog();
    },
  });

  const sectionId = computed(() => {
    //@ts-expect-error
    return mjmlStore.selectedSection.sectionIndex as number;
  });

  function addSection(cols: string) {
    const resolvedCols = resolve(cols);
    let newSectionIndex = sectionId.value;

    if (direction.value === "bottom") {
      newSectionIndex++;
    }

    mjmlStore.addSection({
      sectionIndex: newSectionIndex,
      columns: resolvedCols.structure,
      type: resolvedCols.type,
      byClick: true,
    });

    dialogsStore.closeStructureDialog();
  }
</script>

<style lang="scss" scoped>
  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 158px);
    grid-gap: 16px;
  }

  .body-container {
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
    padding-left: 24px;
    padding-right: 24px;
  }
</style>
